'use client';
import React, { useCallback, useEffect, useState } from 'react';
import HeartOutline from '@heroicons/react/24/outline/HeartIcon';
import HeartSolid from '@heroicons/react/24/solid/HeartIcon';
import { useAuth } from '@/context/auth-context';
import { useModal } from '@/context/modal-context';
import LoginRequiredModal from '@/screen/feed/view/components/like-button/login-required-modal';
import styles from './styles.module.scss';

interface LikeButtonProps {
  isLiked: boolean;
  onChange?: (isLiked: boolean) => void;
  className?: string;
  /** 아이콘 뒤에 함께 누를 수 있게 둘 내용(예: 좋아요 수). */
  children?: React.ReactNode;
}

/**
 * Component for like button
 */
const LikeButton: React.FC<LikeButtonProps> = ({ isLiked, onChange, className = '', children }) => {
  const [isLikeState, setIsLikedState] = useState(isLiked);
  const auth = useAuth();
  const modal = useModal();

  useEffect(() => {
    setIsLikedState(isLiked);
  }, [isLiked]);

  const handlePress = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!auth.me) {
      modal.openModal({
        title: '로그인이 필요해요',
        content: <LoginRequiredModal />,
      });
      return;
    }
    setIsLikedState(!isLikeState);
    onChange?.call(null, !isLikeState);
  }, [isLikeState, auth.me]);

  const iconProps = {
    className: 'w-6 h-6',
    width: 24,
    height: 24,
  };
  return (
    <button
      type="button"
      className={`${styles.button} ${className}`}
      onClick={handlePress}
      aria-pressed={isLikeState}
      aria-label="좋아요"
    >
      {isLikeState ?
        <HeartSolid {...iconProps} color="red" aria-hidden="true" /> :
        <HeartOutline {...iconProps} color="currentColor" aria-hidden="true" />}
      {children}
    </button>
  );
};

export default LikeButton;